// extracted by mini-css-extract-plugin
module.exports = {"rightChevron":"src-components-UI-Buttons-RightChevron-styles-style-module__rightChevron--3VQA2"};